import { Title, Texts, Media } from "../Object";
import { Space } from "../Layout";
import { Scroll } from "../Animation";

const Problem = () => {
  const args = {
    slug: 'problem',
    length: 6,
    repeat: 3,
    addText: [
      '採用してもすぐに辞めてしまい、<br><b>育成が進まない。</b>',
      '人材採用の<b>ノウハウ</b>がない',
      '業務に追われて選考に<br><b>時間がかけられない</b>',
      '<b>優秀な</b>人材確保がしたい',
      '求人媒体は<b>広告費が高く</b><br>採用できるかも不透明',
      '人材雇用をして<br><b>会社の成長</b>をしていきたい',
    ],
  }
  return(
    <>
      <div className="l-row l-row--normal">
        <Title slug="problem" type="center"></Title>
        <Space size={['64px 0 0', '48px 0 0']}>
          <List {...args} />
        </Space>
      </div>
    </>
  )
}

export const List = (props) => {
  const args = {
    slug: props.slug ?? "problem",
    length: props.length ?? 3,
    addText: props.addText,
    repeat: props.repeat,
  };
  const Item = (props) => {
    return (
      <>
        <Scroll>
          <li
            className="c-grid__items--square"
            data-state={`repeat-${args.length}`}
          >
            <Space size={["0 0 40px", "0 0 32px"]}>
              <Media
                class="p-img__char"
                alt="problem"
                src={`${args.slug}/list${props.index}`}
              ></Media>
            </Space>
            <Texts
              class="c-text--center c-text--med c-text--under-line"
              slug={`${args.slug}/list${props.index}`}
              addText={args.addText[props.index]}
            />
          </li>
        </Scroll>
      </>
    );
  };
  let items = [];
  for (let i = 0; i < args.length; i++) {
    items.push(<Item key={i} index={i} />);
  }

  return (
    <>
      <ul className={`c-grid__wrap--repeat-${args.repeat}`}>{items}</ul>
    </>
  );
};

export default Problem;